<div class="save-survey-modal-container">

    <div class="save-survey-modal-header">
        Salva la ricerca
    </div>

    <div class="save-survey-modal-content">

        <p>Nome del salvataggio: </p>
        <input aria-label="Nome del salvataggio" class="form-control comparatoreMF-box-shadow" [(ngModel)]="saveName" />

        <div class="form-check answer mt-2" [hidden]="isOverrideCBHidden">
            <input class="form-check-input" type="checkbox" [(ngModel)]="isOverride" id="IsOverrideSurveySaveCB">
            <label class="form-check-label" for="IsOverrideSurveySaveCB">
                <p>Sovrascrivere il salvataggio</p>
            </label>
        </div>

    </div>

    <div class="save-survey-modal-footer-container">

        <app-btn (click)="closeDialog('canceled')" class="mx-1" padding="6px 24px"><span class="btn-txt">Annulla</span></app-btn>
        <app-btn (click)="save()" padding="6px 24px" [disabled]="saveName?.length == 0"><span class="btn-txt">Conferma</span></app-btn>

    </div>

</div>